import React from 'react'
import {MdLanguage, MdOutlineLogout} from 'react-icons/md'
import {GrLocation} from 'react-icons/gr'
import {useState,useEffect} from 'react'
import {AiOutlineQuestionCircle} from 'react-icons/ai'
import {GiHamburgerMenu} from 'react-icons/gi'
import {BsHandbag} from 'react-icons/bs'
import {BiUser} from 'react-icons/bi'
import {FiSearch,FiHeart} from 'react-icons/fi'
import classes from '../styles/Layout.module.scss'
import { items } from '../utils/navbarItems'
import { Link,useLocation,useNavigate } from 'react-router-dom'
import Product from './Product'
import { useDispatch,useSelector } from 'react-redux'
import {toggle} from '../redux/features/sidebarSlice'
import {searchForProduct,selectSearch} from '../redux/features/navbarSlice'
import { selectNbrItems,clear } from '../redux/features/cartSlice'
import { selectUser,logout } from '../redux/features/authSlice'
import {FaFacebookF,FaTwitter,FaYoutube,FaInstagram,FaLinkedinIn,FaWeibo} from 'react-icons/fa'
import {RiWechatFill} from 'react-icons/ri'
import { footerItems } from '../utils/footerItems'
import Loader from './Loader'
import Modal from './Modal'
import axios from 'axios'
import * as yup from "yup";
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form'
import {DisplayModal,selectisModalDisplayed,setModalTitle} from '../redux/features/modalSlice'

const Layout = (props) => {
    const dispatch=useDispatch()
    const navigate=useNavigate()
    let nbrOfItems = useSelector(selectNbrItems)
    let isModalDisplayed=useSelector(selectisModalDisplayed)
    let whatWeAreSearchingFor= useSelector(selectSearch)
    const user = useSelector(selectUser)
    const location = useLocation()
  
    const [subscriptionResponse, setSubscriptionResponse] = useState("")

    const logoutHandler=()=>{
        dispatch(logout())
        dispatch(clear())
        navigate('/')
    }

    const [loading, setLoading] = useState(true)
    useEffect(() => {
        setTimeout(()=>{
        setLoading(false)
        },2000)
        dispatch(setModalTitle("Newsletter Subscription"))
    }, [])


    const schema = yup.object({
        email: yup.string().required().email()
    });

    const {handleSubmit,register,formState: { errors }} = useForm({
        resolver: yupResolver(schema)
    });

    const submitHandler=async(info)=>{
        const email=info.email;
        const { data } = await axios.post(process.env.REACT_APP_BACKEND_URL+'user/subscribe', {
            email
        });

        console.log("return status code: "+data.status)
        
        console.log("this is the entered email: "+email)
        console.log(data.msg)
        dispatch(DisplayModal())
        setSubscriptionResponse(data.msg)
    }


    return (
        
        <div>
            {loading && location.pathname==="/" ? <Loader /> : 
            <div>
                {isModalDisplayed && <Modal>{subscriptionResponse}</Modal>}
                  

                        <header>
                            <div className={classes.header}>
                                <div className={classes.header__left}>
                                    <div className={classes.header__left__pos}><GrLocation className={classes.nav_item+" "+classes.header__icon} /><div>Tunisia</div></div>
                                    <div className={classes.header__left__lang}><MdLanguage className={classes.nav_item+" "+classes.header__icon} /><div className={classes.header__item+" "+classes.nav_item}>English</div></div>
                                </div>
                                <div className={classes.header__center+" "+classes.nav_item}>Free shipping for orders above 150 TND</div>
                                <div className={classes.header__right}><AiOutlineQuestionCircle className={classes.nav_item+" "+classes.header__icon} /><div className={classes.header__item+" "+classes.nav_item}>Customer Service</div></div>
                            </div>
                            <nav className={classes.navbar}>
                                <div className={classes.navbar__left}>
                                    <div className={classes.navbar__left__brand+" "+classes.nav_item}><Link style={{ textDecoration: 'none',color:'black' }} to="/"><img src={'/images/velocityprime_logo.png'} alt=""/></Link></div>
                                    {/* <div className={classes.navbar__left_right}> */}
                                        <div className={classes.navbar__item+" "+classes.navbar_item_mobile__cart}>{nbrOfItems>0 && <div className={classes.nbr_items}>{nbrOfItems}</div>}<BsHandbag onClick={()=>navigate('/cart')} className={classes.navbar__right__icon+" "+classes.nav_item} /></div>
                                        <div className={classes.navbar__left__toggle+" "+classes.nav_item}><GiHamburgerMenu onClick={()=>dispatch(toggle(true))}/></div>
                                    {/* </div> */}
                                </div>
                                <div className={classes.navbar__items}>
                                    {items.map((item,index)=><div key={index} className={classes.navbar__item+" "+classes.navbar__items__item+" "+classes.nav_item}><Link style={{ textDecoration: 'none',color:'black' }} to={item ==="home" ? "/":"/"+item}>{item}</Link></div>)}
                                </div>
                                <div className={classes.navbar__right}>

                                    <div className={classes.navbar__right__search_wrapper}><div><FiSearch className={classes.navbar__right__icon+" "+classes.nav_item} /></div><input type="search" placeholder="Search" value={whatWeAreSearchingFor} onChange={(e)=> dispatch(searchForProduct(e.target.value))} className={classes.search} /></div>
                                    <div className={classes.navbar__item}><Link style={{ textDecoration: 'none',color:'black' }} to={user != null ? "/admin/dashboard" : "/admin/login"}><BiUser className={classes.navbar__right__icon+" "+classes.nav_item} /></Link></div> 
                                    {/* <div className={classes.navbar__item}><FiHeart className={classes.navbar__right__icon+" "+classes.nav_item} /></div> */}
                                    <div className={classes.navbar__item}><MdOutlineLogout onClick={logoutHandler} className={classes.navbar__right__icon+" "+classes.nav_item} /></div>

                                    <div className={classes.navbar__item+" "+classes.navbar_item__cart}>{nbrOfItems>0 && <div className={classes.nbr_items}>{nbrOfItems}</div>}<BsHandbag onClick={()=>navigate('/cart')} className={classes.navbar__right__icon+" "+classes.nav_item} /></div>
                                </div>
                            </nav>
                        </header>
                        
                        <main>
                        
                            
                            <div>
                                {props.children}
                            </div>
                            
                        
                        </main>
                        
                    
                        <footer>
                            <div className={classes.top_row}>
                                {/* <div className={classes.col_left}>
                                    <img src={'/images/paymentondelivery_color.svg'} width="90px" height="90px" alt="" />
                                    <img src={'/images/fastshipping_color.svg'} width="90px" height="90px" alt="" />
                                    <img src={'/images/freereturns_color.svg'} width="90px" height="90px" alt="" />
                                </div> */}
                                
                                <div className={classes.col_left}>
                                    <Link style={{ textDecoration: 'none',color:'black'}} to="/"><b>Velocity'</b></Link>
                                </div>
                                <div className={classes.col_mid + " " + classes.interline}>
                                    <div>Subscribe to our newsletter</div>
                    
                                    <form className={classes.form} onSubmit={handleSubmit(submitHandler)}>
                                        <input className={classes.subscribe_email} data-test="email-input" type="email" placeholder="" {...register("email")} />
                                        <input className={classes.subscribe_btn} data-test="subscribe-btn" type="submit" value="Subscribe" />
                                    </form>
                                </div>
                            
                                <div className={classes.col_right} data-test="social-media-links">
                                    <a target='_blank' style={{ textDecoration: 'none',color:'black'}}  rel='noopener noreferrer' href='https://www.facebook.com/'><FaFacebookF className={classes.icon}/></a>
                                    <a target='_blank' style={{ textDecoration: 'none',color:'black'}}  rel='noopener noreferrer' href='https://www.youtube.com/'><FaYoutube className={classes.icon}/></a>
                                    <a target='_blank' style={{ textDecoration: 'none',color:'black'}}  rel='noopener noreferrer' href='https://www.instagram.com/velocity_prime_/'><FaInstagram className={classes.icon}/></a>
                                </div>
                            </div>
                            <div className={classes.bottom_row}>
                                <b data-test="copyright">Copyright @ 2025 Velocity'</b>
                            </div>
                        </footer>
                 
        </div>
        }
        </div>
    )
}

export default Layout
